export default {
	defaultProps: {
		disableElevation: true,
	},
	styleOverrides: {
		root: {
			borderRadius: '8px',
			padding: '6px 24px',
			fontSize: '16px',
			fontWeight: 600,
			lineHeight: '140%',
			letterSpacing: '0.15px',
		},
	},
};
